import React, { Component } from "react";

// @ts-ignore
import cn from "classnames";
import Markdown from "../../../components/Markdown";
import WorkflowStepAlert from "./WorkflowStepAlert";
import {
  workflowStepCN,
  workflowStepServiceCN,
  workflowStepServiceIdLabelCN,
  workflowStepBottomAlertCN,
  workflowStepServiceBottomAlertCN,
  workflowStepContentCN,
  workflowStepIdLabelCN,
  workflowStepContentTitleCN,
  workflowStepServiceContentTitleCN,
  workflowStepContentDescriptionCN,
  workflowStepServiceContentDescriptionCN,
  workflowStepServiceFutureAlertCN,
} from "./styles";

import type { WorkflowStep } from "../../../../redux/modules/workflow/reducer";
import RollbackButton from "./RollbackButton";

interface WorkflowStepSuccessfulProps {
  step: WorkflowStep;
  isRollbackAvailable: boolean;
  onRollback: () => void;
  isRunning: boolean;
};

export default class WorkflowStepService extends Component<WorkflowStepSuccessfulProps> {
  render() {
    const { id, title, descriptionMd } = this.props.step;
    const { isRunning, isRollbackAvailable } = this.props;

    return (
      <div
        id={`workflow-step-${id}`}
        className={cn(workflowStepCN, workflowStepServiceCN, {
          ["autotest-workflow-service-step-running"]: isRunning,
        })}
      >
        <div
          className={cn(workflowStepServiceIdLabelCN, workflowStepIdLabelCN)}
        >
          {isRunning ? <img src="ic-workflow-status-progress.svg" /> : id}
        </div>
        <div className={workflowStepContentCN}>
          {isRollbackAvailable ? (
            <RollbackButton onClick={() => this.props.onRollback()} />
          ) : null}
          <div
            className={cn(
              workflowStepContentTitleCN,
              workflowStepServiceContentTitleCN,
            )}
          >
            {title}
          </div>
          <div
            className={cn(
              workflowStepContentDescriptionCN,
              workflowStepServiceContentDescriptionCN,
            )}
          >
            <Markdown text={descriptionMd} />
          </div>
          {!isRunning && this.renderServiceFutureAlert()}
        </div>
        {this.renderBottomAlert()}
      </div>
    );
  }

  renderServiceFutureAlert() {
    return (
      <div className={workflowStepServiceFutureAlertCN}>
        This step does not require any action.
      </div>
    );
  }

  renderBottomAlert() {
    if (!this.props.isRunning) {
      return null;
    }
    // TODO make separate WorkflowStepAlert message for different workflow types and roles, similar to strings.getWorkflowDescription
    return (
      <div
        className={cn(
          workflowStepBottomAlertCN,
          workflowStepServiceBottomAlertCN,
        )}
      >
        <WorkflowStepAlert
          header={"This may take a while."}
          message={
            "You will receive an email once the data is processed and available in TraceAir Office."
          }
        />
      </div>
    );
  }
}
